import styled from '@emotion/styled'
import { color, font, size } from '../../styles'

interface Props {
   label: string
   value: string | number | null | undefined
   size?: 'small' | 'medium'
   className?: string
}

const KeyValueInfo: React.FC<Props> = ({ label, value, size, className }) => {
   if (!value) return null // if value is null or undefined, don't render anything
   return (
      <Holder className={(size || 'small ') + ' ' + (className || '')}>
         <p className="key">{label}</p>
         <p className="value">{value}</p>
      </Holder>
   )
}

const Holder = styled.div`
   --key-background-color: #e0e0e0;
   --value-background-color: #a5a5a5;

   display: flex;
   align-items: center;
   border-radius: 5em;
   overflow: hidden;
   border: 1px solid var(--value-background-color);

   p {
      font-size: 1em;
      padding: 0.2em 0.9em;
      padding-top: 0.3em;
      line-height: 0;
      margin: 0;
      ${font.thin};
      white-space: nowrap;
   }

   .key {
      background-color: var(--key-background-color);
      color: ${color.grayDark};
      text-transform: capitalize;
      position: relative;

      &:after {
         content: '';
         position: absolute;
         top: 0;
         right: 0;
         width: 4px;
         z-index: 2;
         height: 100%;
         background-color: var(--holder-background-color, ${color.white});
      }
   }

   .value {
      background-color: var(--value-background-color);
      padding-left: 0.4em;
      color: ${color.white};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   }

   &.small {
      font-size: ${size.s};
   }
   &.medium {
      font-size: ${size.m};
   }
`

export default KeyValueInfo
